<!-- =========================================================================================
    File Name: Chat.vue
    Description: Chat Application - Stay connected
    ----------------------------------------------------------------------------------------
    Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
      Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->


<template>
    <div class="px-6 pt-2">
        <div id="chat-app" class="border border-solid d-theme-border-grey-light relative overflow-hidden"
             style="border-radius: 20px">
            <vs-sidebar class="items-no-padding" parent="#chat-app" :click-not-close="clickNotClose"
                        :hidden-background="clickNotClose" v-model="isChatSidebarActive" id="chat-list-sidebar">

                <!-- USER PROFILE SIDEBAR -->
                <user-profile :active="activeProfileSidebar" :dataUser="dataUser" class="user-profile-container"
                              :isLoggedInUser="isLoggedInUserProfileView"
                              @closeProfileSidebar="closeProfileSidebar"></user-profile>

                <div class="chat__profile-search flex p-4">
                    <vs-input icon-no-border icon="icon-search" icon-pack="feather"
                              class="w-full mx-5 input-rounded-full"
                              placeholder="Nhập tên ..." v-model="searchQuery"/>

                    <feather-icon class="md:inline-flex lg:hidden -ml-3 cursor-pointer" icon="XIcon"
                                  @click="toggleChatSidebar(false)"/>
                </div>

                <vs-divider class="d-theme-border-grey-light m-0"/>

                <vs-tabs position="left" v-model="activeTab">
                    <vs-tab label="" icon="chat">
                        <h3 class="text-primary mb-3 px-4">Tin nhắn</h3>
                        <VuePerfectScrollbar class="chat-scroll-area mt-2" :settings="settings" :key="$vs.rtl"
                                             @ps-scroll-y="scrollHandleChats" :style="{maxHeight: `${heightScroll}px`}">
                            <!-- ACTIVE CHATS LIST -->
                            <div class="chat__chats-list">
                                <ul class="chat__active-chats bordered-items">
                                    <li class="cursor-pointer" v-for="(contact, index) in historyChat" :key="index"
                                        @click="updateActiveChatUser(contact, true)" :style="{'background-color': contact.id === activeChatUser ? 'rgba(var(--vs-primary),.2)' : null}">
                                        <chats :contact="contact" :userInfo="userInfo"></chats>
                                    </li>
                                </ul>
                            </div>
                        </VuePerfectScrollbar>
                    </vs-tab>
                    <vs-tab label="" icon="grade">
                        <h3 class="text-primary mb-3 px-4">Ưu tiên</h3>
                        <VuePerfectScrollbar class="chat-scroll-area mt-2" :settings="settings" :key="$vs.rtl"
                                             @ps-scroll-y="scrollHandleChats" :style="{maxHeight: `${heightScroll}px`}">

                            <!-- ACTIVE CHATS LIST TAG -->
                            <div class="chat__chats-list">
                                <ul class="chat__active-chats bordered-items">
                                    <li class="cursor-pointer" v-for="(contact, index) in prioritizeChat" :key="index"
                                        @click="updateActiveChatUser(contact, true)" :style="{'background-color': contact.id === activeChatUser ? 'rgba(var(--vs-primary),.2)' : null}">
                                        <chats :contact="contact" :userInfo="userInfo" :chatId="activeChatUser"></chats>
                                    </li>
                                </ul>
                            </div>
                        </VuePerfectScrollbar>
                    </vs-tab>
                    <vs-tab label="" icon="perm_contact_calendar">
                        <h3 class="text-primary mb-3 px-4">Danh bạ</h3>
                        <VuePerfectScrollbar class="chat-scroll-area mt-2" :settings="settings" :key="$vs.rtl"
                                             @ps-scroll-y="scrollHandleContacts"
                                             :style="{maxHeight: `${heightScroll}px`}">
                            <!-- CONTACTS LIST -->
                            <div class="chat__contacts">
                                <ul class="chat__contacts bordered-items">
                                    <li class="cursor-pointer" v-for="(contact, index) in contactAll" :key="index"
                                        @click="updateActiveChatUser(contact, false)">
                                        <contact :contact="contact"></contact>
                                    </li>
                                </ul>
                            </div>
                        </VuePerfectScrollbar>
                    </vs-tab>
                    <vs-tab label="" icon="settings">
                        <h3>Cài đặt</h3>
                        <VuePerfectScrollbar class="chat-scroll-area pt-4" :settings="settings" :key="$vs.rtl"
                                             :style="{maxHeight: `${heightScroll}px`}">

                            <div class="setting__chats-list">
                                <span class="font-semibold text-md text-primary">Môi trường</span>
                                <div class="flex flex-wrap justify-center mt-1 gap-4">
                                    <div class="img-hover-jump px-3" @click="changeWorkspace(true)"
                                         :class="workSpace  ? 'img-container-space-on' : 'img-container-space-off'">
                                        <div class="w-1/8 flex justify-center">
                                            <img src="../../../assets/images/icon/hrm.png" height="33" width="33"/>
                                        </div>
                                        <span class="ml-auto">HRM</span>
                                    </div>

                                    <div class="img-hover-jump px-3" @click="changeWorkspace(false)"
                                         :class="!workSpace ? 'img-container-space-on' : 'img-container-space-off'">
                                        <div class="w-1/8 flex justify-center">
                                            <img src="../../../assets/images/icon/crm.png" height="33" width="33"/>
                                        </div>
                                        <span class="ml-auto">CRM</span>
                                    </div>
                                </div>
                            </div>
                        </VuePerfectScrollbar>
                    </vs-tab>
                    <vs-tab label="" icon="logout" @click="backToWorkspace"></vs-tab>
                </vs-tabs>

            </vs-sidebar>

            <!-- RIGHT COLUMN -->
            <div
                class="chat__bg no-scroll-content chat-content-area border border-solid d-theme-border-grey-light border-t-0 border-r-0 border-b-0"
                :class="{'sidebar-spacer--wide': clickNotClose, 'flex items-center justify-center': activeChatUser === null}">
                <template v-if="activeChatUser">
                    <div class="chat__navbar">
                        <chat-navbar :isSidebarCollapsed="!clickNotClose" :user-id="activeChatUser"
                                     :isPinnedProp="isChatPinned" @openContactsSidebar="toggleChatSidebar(true)"
                                     @showProfileSidebar="showProfileSidebar"
                                     @toggleIsChatPinned="toggleIsChatPinned" :dataUser="dataUser"></chat-navbar>
                    </div>
                    <VuePerfectScrollbar class="chat-content-scroll-area border border-solid d-theme-border-grey-light"
                                         :settings="settings" ref="chatLogPS" :key="$vs.rtl"
                                         @ps-scroll-y="scrollHandleMessage">
                        <div class="chat__log" ref="chatLog">
                            <chat-log :userId="activeChatUser" v-if="activeChatUser" :chatData="chatData"></chat-log>
                        </div>
                    </VuePerfectScrollbar>
                    <div class="chat__input p-4 bg-white flex">
                        <input type="file" ref="imageInput" accept="image/*" @change="handleImageUpload"
                               class="hidden"/>
                        <input type="file" ref="videoInput" accept="video/mp4" @change="handleVideoUpload"
                               class="hidden"/>
                        <vs-input class="flex-1" placeholder="Nhập tin nhắn ..." v-model="typedMessage"
                                  @keyup.enter="sendMsg"/>
                        <feather-icon icon="FilmIcon" class="ml-2 text-primary" svgClasses="w-7 h-7"
                                      @click="$refs.videoInput.click()"></feather-icon>
                        <feather-icon icon="ImageIcon" class="ml-2 text-primary" svgClasses="w-8 h-8"
                                      @click="$refs.imageInput.click()"></feather-icon>
                        <vs-button class="bg-primary-gradient ml-2" type="filled" @click="sendMsg">Gửi</vs-button>
                    </div>
                </template>
                <template v-else>
                    <div class="flex flex-col items-center">
                        <feather-icon icon="MessageSquareIcon" class="mb-4 bg-white p-8 shadow-md rounded-full"
                                      svgClasses="w-16 h-16" @click.stop="toggleChatSidebar(true)"></feather-icon>
                        <h4 class=" py-2 px-4 bg-white shadow-md rounded-full cursor-pointer"
                            @click.stop="toggleChatSidebar(true)">Bắt đầu cuộc trò chuyện</h4>
                    </div>
                </template>
            </div>
        </div>
    </div>
</template>

<script>
import Contact from "./ChatContact.vue"
import ChatLog from './ChatLog.vue'
import ChatNavbar from './ChatNavbar.vue'
import UserProfile from "./UserProfile.vue"
import Chats from "./ChatHistory"
import VuePerfectScrollbar from 'vue-perfect-scrollbar'
// import moduleChat from '@/store/chat/moduleChat.js'

export default {
    data() {
        return {
            active: true,
            isHidden: false,
            searchContact: "",
            activeProfileSidebar: false,
            activeChatUser: null,
            userProfileId: -1,
            typedMessage: '',
            isChatPinned: false,
            settings: {
                maxScrollbarLength: 60,
                wheelSpeed: 0.70,
            },
            clickNotClose: true,
            isChatSidebarActive: true,
            isLoggedInUserProfileView: false,
            activeTab: 0,
            socketChat: null,
            contactAll: [],
            historyChat: [],
            prioritizeChat: [],
            allDataChat: [],
            dataUser: null,
            chatData: [],
            pageNumberChatData: 0,
            pageSizeChatData: 10,
            dataCreate: null,
            heightScroll: 0,
            imageUpload: [],
            videoUpload: [],
            fileUpload: [],
            userInfo: null,
            marginTopInput: 116,
            searchQuery: '',
        }
    },
    watch: {
        windowWidth() {
            this.setSidebarWidth()
        },
    },
    computed: {
        // searchQuery: {
        //     get() {
        //         return ''
        //     },
        //     set(val) {
        //     }
        // },
        isActiveChatUser() {
            return (userId) => userId == this.activeChatUser
        },
        windowWidth() {
            return this.$store.state.windowWidth
        },

        workSpace() {
            let space = localStorage.getItem('work_space');
            if (space === 'hrm') return true;
            return false
        }
    },
    methods: {
        closeProfileSidebar(value) {
            this.activeProfileSidebar = value
        },
        async updateActiveChatUser(contact, status) {
            if (this.activeChatUser !== contact.id) {
                await this.getOrCreateChat(contact, status);
                this.activeChatUser = this.dataUser.id;
                this.chatData = [];
                this.pageNumberChatData = 0;
                this.pageSizeChatData = 10;
                await this.getDataChat();
                if (!status) this.activeTab = 0;
                await this.getHistoryChat();
            }
            this.toggleChatSidebar();
            this.typedMessage = '';
            this.imageUpload = [];
            this.videoUpload = [];
            this.fileUpload = [];
        },
        showProfileSidebar(userId, openOnLeft = false) {
            this.userProfileId = userId;
            this.isLoggedInUserProfileView = openOnLeft;
            this.activeProfileSidebar = !this.activeProfileSidebar;
        },
        sendMsg() {
            this.typedMessage = this.typedMessage.trim();
            if (this.typedMessage.length === 0 && this.imageUpload.length === 0 && this.videoUpload.length === 0 && this.fileUpload.length === 0) {
                return this.$vs.notify({
                    text: 'Tin nhắn bắt buộc phải có nội dung!',
                    iconPack: 'feather',
                    icon: 'icon-alert-circle',
                    color: 'danger'
                });
            }
            const formData = new FormData();
            formData.append('text ', this.typedMessage);
            formData.append('chatId ', this.activeChatUser);
            if (this.imageUpload.length > 0) this.imageUpload.forEach(x => formData.append('images', x));
            if (this.videoUpload.length > 0) this.videoUpload.forEach(x => formData.append('videos', x));
            if (this.fileUpload.length > 0) this.fileUpload.forEach(x => formData.append('files', x))
            this.$vs.loading();

            this.$crm.post('/chat-message/send', formData).then(() => {
                this.$vs.loading.close();
            }).catch(err => {
                this.$vs.loading.close();
                return this.$vs.notify({
                    text: err.response.data.message || err.response.data.error_description || err.response.data.error,
                    iconPack: 'feather',
                    icon: 'icon-alert-circle',
                    color: 'danger'
                });
            });
            this.typedMessage = '';
            this.imageUpload = [];
            this.videoUpload = [];
            this.fileUpload = [];
            this.$refs.chatLogPS.$el.scrollTop = this.$refs.chatLog.scrollHeight
        },
        toggleIsChatPinned(value) {
            this.isChatPinned = value
        },
        setSidebarWidth() {
            if (this.windowWidth < 1024) {
                this.isChatSidebarActive = this.clickNotClose = false
            } else {
                this.isChatSidebarActive = this.clickNotClose = true
            }
        },
        toggleChatSidebar(value = false) {
            if (!value && this.clickNotClose) return
            this.isChatSidebarActive = value;
            this.activeTab = 2;
        },
        handleImageUpload(event) {
            this.imageUpload = [...event.target.files];
            this.imageUpload.forEach((file) => {
                const reader = new FileReader();
                reader.onload = function (e) {
                    file.src = e.target.result;
                }
                reader.readAsDataURL(file);
            });

            // Clear the file input
            this.$refs.imageInput.value = null;
            this.sendMsg();
        },
        handleVideoUpload(event) {
            this.videoUpload = [...event.target.files];
            this.videoUpload.forEach((file) => {
                const reader = new FileReader();
                reader.onload = function (e) {
                    file.src = e.target.result;
                }
                reader.readAsDataURL(file);
            });

            // Clear the file input
            this.$refs.videoInput.value = null;
            this.sendMsg();
        },
        getOrCreateUserChat() {
            return new Promise((resolve, reject) => {
                this.$vs.loading();
                this.$crm.post('/chat-user/get-or-create-user', {}).then(() => {
                    resolve();
                    this.$vs.loading.close();
                }).catch(err => {
                    reject();
                    this.$vs.loading.close();
                    return this.$vs.notify({
                        text: err.response.data.message || err.response.data.error_description || err.response.data.error,
                        iconPack: 'feather',
                        icon: 'icon-alert-circle',
                        color: 'danger'
                    });
                });
            })
        },
        getSessionChat() {
            return new Promise((resolve, reject) => {
                this.$crm.get('/chat-user/get-session').then(res => {
                    this.socketChat = new WebSocket(
                        `wss://api.chatengine.io/person_v4/?session_token=${res.data.token}`
                    );
                    resolve();
                }).catch(err => {
                    reject();
                    this.$vs.loading.close();
                    return this.$vs.notify({
                        text: err.response.data.message || err.response.data.error_description || err.response.data.error,
                        iconPack: 'feather',
                        icon: 'icon-alert-circle',
                        color: 'danger'
                    });
                });
            })
        },
        scrollHandleChats() {
        },
        scrollHandleContacts() {
        },

        scrollHandleMessage(event) {
            const {scrollTop, offsetHeight, scrollHeight} = event.target
            // console.log(scrollTop, offsetHeight, scrollHeight)
            if (scrollTop === 0) {
                this.pageNumberChatData += 1;
                this.getDataChat();
            }
        },

        getAllUserChat() {
            return new Promise((resolve, reject) => {
                this.$crm.post('/chat-user/get-all', {}).then(res => {
                    this.contactAll = res.data.data;
                    resolve();
                }).catch(err => {
                    reject();
                    this.$vs.loading.close();
                    return this.$vs.notify({
                        text: err.response.data.message || err.response.data.error_description || err.response.data.error,
                        iconPack: 'feather',
                        icon: 'icon-alert-circle',
                        color: 'danger'
                    });
                });
            })
        },
        getHistoryChat() {
            return new Promise((resolve, reject) => {
                this.$vs.loading();
                this.$crm.post('/group-chat/get-current-user-chats', {}).then(res => {
                    this.allDataChat = res.data.data.map(el => {
                        el.people = el.people.filter(t => t.person.username !== this.userInfo.username);
                        el.people.forEach(x => {
                            x.person.custom_json = JSON.parse(x.person.custom_json)
                        })
                        return el;
                    });
                    this.historyChat = this.allDataChat.filter(t => !t.isMarkPriority)
                    this.prioritizeChat = this.allDataChat.filter(t => t.isMarkPriority);
                    this.$vs.loading.close();
                    resolve();
                }).catch(err => {
                    reject();
                    this.$vs.loading.close();
                    return this.$vs.notify({
                        text: err.response.data.message || err.response.data.error_description || err.response.data.error,
                        iconPack: 'feather',
                        icon: 'icon-alert-circle',
                        color: 'danger'
                    });
                });
            })
        },
        getOrCreateChat(contact, status) {
            return new Promise((resolve, reject) => {
                this.$vs.loading();
                let payload = {
                    is_direct_chat: true,
                }

                if (status) {
                    let people = contact.people.find(el => el.person.username !== this.userInfo.username);
                    payload['usernames'] = [people.person.username]
                } else {
                    payload['usernames'] = [contact.username]
                }

                this.$crm.post('/group-chat/get-or-create-chat', payload).then(res => {
                    let result = res.data.data.people.find(el => el.person.username !== this.userInfo.username);
                    this.dataUser = result.person;
                    this.dataUser['id'] = res.data.data.id;
                    this.dataUser['isMarkPriority'] = contact.isMarkPriority;
                    this.dataUser.custom_json = JSON.parse(this.dataUser.custom_json);
                    resolve(res)
                    this.$vs.loading.close();
                }).catch(err => {
                    reject(err)
                    this.$vs.loading.close();
                    return this.$vs.notify({
                        text: err.response.data.message || err.response.data.error_description || err.response.data.error,
                        iconPack: 'feather',
                        icon: 'icon-alert-circle',
                        color: 'danger'
                    });
                });
            })
        },
        getDataChat() {
            return new Promise((resolve, reject) => {
                this.$vs.loading();
                let payload = {
                    chatId: this.activeChatUser,
                    pageNumber: this.pageNumberChatData,
                    pageSize: this.pageSizeChatData,
                }
                this.$crm.post('/chat-message/find-by-condition', payload).then(res => {
                    let result = res.data.content.reverse();
                    this.chatData.unshift(...result);
                    this.chatData.forEach(el => {
                        el.customJson = typeof el.customJson === 'string' ? JSON.parse(`${el.customJson}`) : el.customJson;
                    })
                    resolve(res);
                    this.$vs.loading.close();
                }).catch(err => {
                    reject(err)
                    this.$vs.loading.close();
                    return this.$vs.notify({
                        text: err.response.data.message || err.response.data.error_description || err.response.data.error,
                        iconPack: 'feather',
                        icon: 'icon-alert-circle',
                        color: 'danger'
                    });
                });
            })
        },

        changeWorkspace(status) {
            localStorage.setItem("work_space", status ? 'hrm' : 'crm');
            location.reload()
        },

        backToWorkspace() {
            localStorage.setItem("isChat", false);
            localStorage.setItem("work_space", null);
            return this.$router.push('/pages/select-work-space').catch(() => {
            });
        },

        getChatById() {
            return new Promise((resolve, reject) => {
                this.$vs.loading();
                let payload = {
                    is_direct_chat: true,
                    chatId: this.activeChatUser,
                }

                this.$crm.post('/group-chat/get-chat-by-id', payload).then(res => {
                    let result = res.data.data.people.find(el => el.person.username !== this.userInfo.username);
                    this.dataUser = result.person;
                    this.dataUser['id'] = res.data.data.id;
                    // this.dataUser['isMarkPriority'] = contact.isMarkPriority;
                    this.dataUser.custom_json = JSON.parse(this.dataUser.custom_json);
                    resolve(res)
                    this.$vs.loading.close();
                }).catch(err => {
                    reject(err)
                    this.$vs.loading.close();
                    return this.$vs.notify({
                        text: err.response.data.message || err.response.data.error_description || err.response.data.error,
                        iconPack: 'feather',
                        icon: 'icon-alert-circle',
                        color: 'danger'
                    });
                });
            })
        },
    },
    components: {
        VuePerfectScrollbar,
        Contact,
        UserProfile,
        ChatNavbar,
        ChatLog,
        Chats,
    },
    async created() {
        this.userInfo = JSON.parse(localStorage.getItem('userInfo'));
        await this.getOrCreateUserChat();
        await this.getSessionChat();
        await this.getAllUserChat();
        await this.getHistoryChat();
        this.setSidebarWidth();
        let id = this.$route.query.chatId;
        if (id) {
            this.activeChatUser = parseInt(id, 10);
            await this.getChatById();
            this.chatData = [];
            this.pageNumberChatData = 0;
            this.pageSizeChatData = 10;
            await this.getDataChat();
            this.activeTab = 0;
        }
    },
    updated() {
        this.socketChat.onmessage = async (event) => {
            let result = JSON.parse(event.data)
            if (result.action === 'edit_chat') {
                let editChat = this.allDataChat.find(el => el.id === result.data.id);
                if (!editChat) await this.getHistoryChat();
                if (this.dataUser) {
                    if (result.data.last_message.sender_username === this.dataUser.username) {
                        this.dataUser.is_online = true;
                    }
                }
                this.historyChat = this.historyChat.filter(el => el.id !== result.data.id);
                editChat.last_message = result.data.last_message;
                let people = result.data.people.find(el => el.person.username !== this.userInfo.username)
                editChat.people[0].person.is_online = people.person.is_online;
                this.historyChat.unshift(editChat);
            }
            if (result.action === 'new_message') {
                // if (this.chatData.length === 0) await this.getDataChat();
                if (this.activeChatUser === result.data.id) {
                    let data = {
                        attachments: result.data.message.attachments,
                        chatEngineMessageId: result.data.message.id,
                        chatId: result.data.id,
                        customJson: JSON.parse(result.data.message.custom_json),
                        sendAt: result.data.message.created,
                        senderAvatar: JSON.parse(result.data.message.sender.custom_json).avatarUrl,
                        senderUsername: result.data.message.sender_username,
                        text: result.data.message.text,
                    }
                    this.chatData.push(data);
                }
            }
        };

        let h = document.getElementById('chat-app').clientHeight;
        this.heightScroll = h - 120;
    },

    mounted() {
        this.$eventBus.$on("priority-success", async ($event) => {
            let result = this.allDataChat.find(el => el.id === $event.id);
            result.isMarkPriority = !$event.isMarkPriority;
            if (result) {
                await this.getHistoryChat();
                await this.getOrCreateChat(result, true);
                if ($event.isMarkPriority) this.activeTab = 0;
                if (!$event.isMarkPriority) this.activeTab = 1;
            }
        })
    },

    destroyed() {
        this.socketChat.close();
    }
}

</script>


<style lang="scss">
@import "./src/assets/scss/vuexy/apps/chat.scss";
</style>
